import React from 'react';
import { default as ReactSelect } from 'react-select';
import { components } from 'react-select';

function SummaryAgent({ summaryUser, setAgent }) {
  let optionList = summaryUser?.map((item) => {
    return { value: item?.user?.id, label: item?.user?.first_name };
  });

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{' '}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  function handleSelect(data) {
    setAgent(data);
  }

  return (
    <>
      <ReactSelect
        options={optionList}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option,
        }}
        onChange={handleSelect}
        allowSelectAll={true}
        placeholder="Select Agent"
        styles={{ control: (base) => ({ ...base, width: '16rem',maxHeight:"5rem" ,overflowY:"scroll"}) }}
      />
    </>
  );
}

export default SummaryAgent;
